import apiClient from './apiClient';

export const getEmployees = async () => {
  const response = await apiClient.get('employees');
  return response.data;
};

export const createEmployee = async (employee) => {
  const response = await apiClient.post('employees', employee);
  return response.data;
};
